export default __webpack_public_path__ + "static/media/restart.983980d5.svg";